module.exports = __webpack_public_path__ + "static/background-399c4ab05aaf816518992cc440a9f557.png";